import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureApi } from '@kss/api';
import { refreshSession, logout } from '@kss/auth';
import { initI18n } from '@kss/i18n';
import { applyPersistedBrandColor } from '@kss/theme';
import App from './App';
import { store } from './store';
import './index.css';

initI18n();
applyPersistedBrandColor();

configureApi({
  getSession: () => store.getState().auth.session ?? null,
  setSession: (s) => store.dispatch(refreshSession(s)),
  onUnauthorized: () => {
    store.dispatch(logout('refresh-failed'));
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
